import * as yup from 'yup';
import { isEmail } from 'utils/validation-rules';
import { TFunction } from 'i18next';

export const ForgotPasswordSchema = (t: TFunction) =>
  yup.object({
    email: yup.string().required(t('Field is required')).matches(isEmail, t('Email is incorrect')),
  });
